import { ReactNode } from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { ENV } from '../config/env';
import { AppRoutes } from '../types/appRoutes';
import { resolveRedirectFromStateConnect } from '../utils/stateConnectParser';
import { isSafeInternalPath } from '../utils/redirectValidation';
import { useLogger } from '../context/useLogger';

interface Auth0ProviderWithHistoryProps {
  children: ReactNode;
}

interface CustomAppState extends AppState {
  returnTo?: string;
  stateConnect?: string;
}

const Auth0ProviderWithHistory = ({ children }: Auth0ProviderWithHistoryProps) => {
  const domain = ENV.CLOUDID_DOMAIN || '';
  const clientId = ENV.CLOUDID_CLIENT_ID || '';
  const logger = useLogger();

  const onRedirectCallback = (appState?: CustomAppState) => {
    if (appState?.stateConnect) {
      const redirect = resolveRedirectFromStateConnect(appState.stateConnect, logger);
      if (redirect === 'DsnList') {
        window.location.href = AppRoutes.routeDsnList;
        return;
      }
    }
    window.location.href = isSafeInternalPath(appState?.returnTo)
      ? appState.returnTo
      : AppRoutes.routeDsnList;
  };

  const callbackUrl = `${window.location.origin}/callback`;

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: callbackUrl,
        audience: ENV.CLOUDID_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
